'use client';

import React from 'react';
import { Button } from '@heroui/react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareAccount } from '../types';

interface ActionsCellProps {
  account: RevshareAccount;
  onShowContent: (account: RevshareAccount) => void;
}

const ActionsCell: React.FC<ActionsCellProps> = ({ account, onShowContent }) => {
  const { t } = useTranslations();

  return (
    <div className="flex items-center py-2">
      <Button
        size="sm"
        className="bg-[#E6F1FE] text-partner h-8 rounded-2 px-3.5 text-xs font-normal"
        onPress={() => onShowContent(account)}
      >
        {t('partner.revshare.accounts.contentModal.showContent')}
      </Button>
    </div>
  );
};

export default ActionsCell;
